var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('i',{staticClass:"icon_loading"}),_vm._v("\n  正在加载中......\n")])
}]

export { render, staticRenderFns }